module.exports = __webpack_public_path__ + "img/342.74b3c9bb.png";